export default __webpack_public_path__ + "static/media/icon-checkmark-light.af14ce84.svg";